import { render, staticRenderFns } from "./LocationDeliveryZone.vue?vue&type=template&id=f639783a"
import script from "./LocationDeliveryZone.vue?vue&type=script&lang=ts"
export * from "./LocationDeliveryZone.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports